import {
  QuestionCircleOutlined,
  SafetyCertificateFilled,
  CheckCircleFilled,
  TeamOutlined,
} from '@ant-design/icons';

/**
 * Connector-tier badge (F-AD-14 — Community / Verified / Certified). VIEW-only assurance signal.
 * Colour is always paired with a glyph + text (deuteranopia-safe). An absent/unknown tier renders a
 * neutral "unspecified" (the honest default — the contract's ProviderView does not yet carry a tier).
 */
export function TierBadge({ tier }: { tier?: string }) {
  const t = tier?.toUpperCase?.() ?? '';
  let color = 'var(--ol-text-tertiary)';
  let label = 'Unspecified';
  let icon = <QuestionCircleOutlined aria-hidden />;

  if (t === 'CERTIFIED') {
    color = 'var(--ol-positive)';
    label = 'Certified';
    icon = <SafetyCertificateFilled aria-hidden />;
  } else if (t === 'VERIFIED') {
    color = 'var(--ol-info)';
    label = 'Verified';
    icon = <CheckCircleFilled aria-hidden />;
  } else if (t === 'COMMUNITY') {
    color = 'var(--ol-text-secondary)';
    label = 'Community';
    icon = <TeamOutlined aria-hidden />;
  } else if (tier) {
    // Unknown-but-present token: render it verbatim, neutral.
    label = tier;
  }

  return (
    <span
      title={`Connector tier: ${label}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        color,
        fontSize: 11,
        fontWeight: 600,
        padding: '1px 8px',
        borderRadius: 999,
        border: '1px solid currentColor',
        background: 'color-mix(in srgb, currentColor 8%, transparent)',
        whiteSpace: 'nowrap',
      }}
    >
      {icon}
      {label}
    </span>
  );
}
